import {TabState} from 'Navigation';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {GenericBackboneViewClass} from 'util/Types';

export enum BufferViewType {
  BACKBONE = 'BACKBONE',
}

export type TabViewWithOptionalAfterAttachCallback = Backbone.View<TabState> & {afterAttach?(): void};

interface BackboneTabViewMetadata {
  TabView: GenericBackboneViewClass<TabState, TabViewWithOptionalAfterAttachCallback>;
  tabViewType: BufferViewType.BACKBONE;
}

export type TabViewMetadata = BackboneTabViewMetadata;

interface BackboneOptionsViewMetadata {
  OptionsView: GenericBackboneViewClass<TabState, Backbone.View<TabState>>;
  optionsViewType: BufferViewType.BACKBONE;
}

export type OptionsViewMetadata = BackboneOptionsViewMetadata;

export interface BufferViewMetadata {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tabState: {new (options?: any, attributes?: any): TabState};
  tabViewMetadata: TabViewMetadata;
  optionsViewMetadata?: OptionsViewMetadata;
  dataTestAttrs?: DataTestAttrs;
}
